import ChartBarIcon from '@atlaskit/icon/core/chart-bar';
import * as React from 'react';

export function SvgBarChart() {
  return <ChartBarIcon label="" testId="ads-refreshed-icon" />;
}
